import {
  Box, IconButton, Typography, makeStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  widgetNotificationBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: '#fff7f7',
    color: theme.palette.error.main,
    padding: theme.spacing(0.5, 0.5, 0.5, 6),
    lineHeight: theme.spacing(1.5),
    boxShadow: '0 0 0 2px rgb(176 0 32 / 24%)',
    border: '0px solid rgba(0,0,0,0.25)',
    borderRadius: '1px ',
  },
  WBEsmallFontSize: {
    fontSize: theme.typography.pxToRem(14),
  },
  WBECloseButton: {
    padding: theme.spacing(0.5),
  },
}));
const WidgetNotificationBox = React.memo((props) => {
  const { notificationsList, title } = props;
  const [openError, setOpenError] = useState();
  const classes = useStyles();
  const handleCloseErrorClick = () => setOpenError(false);

  useEffect(() => {
    setOpenError(!!notificationsList);
  }, [notificationsList]);
  return (
    <>
      {openError && notificationsList && (
        <Box className={classes.widgetNotificationBox}>
          <Box>
            {title && (
              <Typography className={classes.WBEsmallFontSize}>{title}</Typography>
            )}
            {notificationsList.map((baseError) => (
              <Typography className={classes.WBEsmallFontSize}>
                {title && (
                  <Typography className={classes.WBEsmallFontSize} component="span">
                    &gt;
                    {' '}
                  </Typography>
                )}
                {' '}
                {baseError}
              </Typography>
            ))}
          </Box>
          <IconButton
            className={classes.WBECloseButton}
            onClick={handleCloseErrorClick}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}
    </>
  );
});

export default WidgetNotificationBox;
